import {
	CustomisationConfig,
	ArchiveCheckbox,
} from '~/components/customisation/customisation-config';

export function getArchiveCheckboxModel(
	customisationConfig: CustomisationConfig,
): ArchiveCheckboxModel {
	const model: ArchiveCheckboxModel = {
		archiveCheckboxHidden: false,
		archiveCheckboxChecked: false,
	};
	const checkbox: ArchiveCheckbox =
		customisationConfig?.functionConfig?.archiveCheckbox;
	if (!checkbox) {
		return model;
	}

	if (checkbox === ArchiveCheckbox.HIDDEN) {
		model.archiveCheckboxHidden = true;
		model.archiveCheckboxChecked = false;
	} else if (checkbox === ArchiveCheckbox.CHECKED) {
		model.archiveCheckboxHidden = false;
		model.archiveCheckboxChecked = true;
	}

	return model;
}

export function setArchiveQueryParam(
	queryParams: Map<string, string>,
	archiveCheckboxChecked: boolean,
): void {
	queryParams.set('showArchived', archiveCheckboxChecked.toString());
}

export interface ArchiveCheckboxModel {
	archiveCheckboxHidden: boolean;
	archiveCheckboxChecked: boolean;
}
